<template>
  <div>
    <v-checkbox label="Assina CCB" v-model="assinaCCB" @change="retiraPapeis" v-if="!!nomeConjuge" />
    <input-multiselect v-model="model" :clearable="false" :options="papeis" label="Papéis" :required="!nomeConjuge || assinaCCB" :disabled="!assinaCCB && !!nomeConjuge"/>
  </div>
</template>
<script>
export default {
  props: {
    codigoProposta: String,
    value: [],
    assinante: Object,
    nomeConjuge: String,
    cliente: Object,
    isEmitentePJ: Boolean,
    isContratoCartular: Boolean,
    countAvalista: Number,
  },
  data () {
    return {
      proposta: null,
      listBase: [],
      assinaCCB: false,
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    papeis () {
      return this.$param.EST_PAPEIS.map(el => {
        const tipo = this.$api.UI.Format.SomenteNumeros(this.cliente.DocumentoFederal).length === 11 ? 'pf' : 'pj'
        if (el[tipo]) {
          var data = {
            text: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal).toUpperCase(),
            value: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal).toUpperCase(),
          }
          return data
        }
      })
    },
  },
  methods: {
    async submit () {
      const th = this;
      const assinante = th.assinante
      if (!th.assinaCCB) {
        th.model = []
      }

      let arrayInclusao = Array.isArray(th.model) ? [...th.model] : [];
      let arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      if (arrayExclusao.length > 0) {
        arrayExclusao = arrayExclusao.map(papel => {
          return papel.Codigo
        })

        await th.$api.Multiplo.Post('RemoveCCBDigitalAssinaturas', { dto: arrayExclusao })
      }

      if (arrayInclusao.length > 0) {
        th.$api.Multiplo.Post('FindRecordProdutoRede').then(function (res) {
          arrayInclusao = arrayInclusao.map(papel => {
            return {
              CodigoProposta: th.codigoProposta,
              Nome: th.nomeConjuge ? `${assinante.Nome} - CÔNJUGE DE ${th.nomeConjuge}` : assinante.Nome,
              Email: assinante.Email,
              Documento: assinante.DocumentoFederal,
              TelefoneCelular: assinante.TelefoneCelular,
              Descricao: papel,
              NotificarPorEmail: !th.isContratoCartular && th.$aux.NotificaPorEmail.includes(res.ModeloNotificacaoAssinatura),
              NotificarPorWhatsApp: !th.isContratoCartular && th.$aux.NotificaPorWhatsApp.includes(res.ModeloNotificacaoAssinatura)
            }
          })
          const data = {
            dto: {
              CodigoProposta: th.codigoProposta,
              CodigoOperacao: th.model.CodigoOperacao,
            },
            assinantes: arrayInclusao
          }
          th.$api.FluxoIrregular.PropostaAssinaturaCCB(th, data)
        })
      }
    },
    carregarAssinantes (codigoProposta) {
      const th = this;
      const dtoAssinantes = {
        parameters: [
          { name: 'CodigoProposta', value: codigoProposta },
          { name: 'search', value: '' },
        ],
      };

      th.$api.Multiplo.Post('ListCCBDigitalAssinatura', dtoAssinantes).then(assinantes => {
        if (th.$api.UI.PostLoadData(assinantes)) {
          th.$set(th, 'listBase', assinantes.Data.filter(el => el.Documento === th.$api.UI.Format.SomenteNumeros(th.assinante.DocumentoFederal)));
          th.$set(th, 'model', th.listBase.map(({ Descricao }) => Descricao));
          if (th.listBase.length > 0) th.assinaCCB = true;
        }
      });
    },
    retiraPapeis () {
      const th = this;
      if (!th.assinaCCB) {
        th.model = []
      } else {
        th.$set(th, 'model', th.listBase.map(({ Descricao }) => Descricao));
      }
    }
  }
}
</script>
<style scoped>
</style>
